import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { MessageMedium } from 'modules/domains/campaign';
import {
  AnalyticsQuery,
  CHOOSE_CAMPAIGN_COLUMN_SORT_ENUM,
  ExperimentsTableQuery,
} from 'modules/experiments/types';
import { getRaw } from 'services/api';
import client from './ApolloClient';
import {
  fetchAnalyticsMetrics,
  fetchCampaignLabelsQuery,
  fetchCampaignsQuery,
  fetchMessageMediumsQuery,
} from './queries';
import {
  fetchConversionsByEventNamesQuery,
  fetchExperimentAnalyticsBasePageQuery,
  fetchExperimentAnalyticsOverviewTabQuery,
  fetchExperimentAnalyticsPerformanceTabQuery,
  fetchExperimentEditQuery,
  fetchExperimentsTableDataQuery,
} from './queries/experiments';

const MESSAGE_TYPES_AND_SENDERS_URL = '/i/settings/messageTypesAndSenders';

export const getMessageTypesAndSenders = (projectId: number, messageMedium: MessageMedium) =>
  getRaw(`${MESSAGE_TYPES_AND_SENDERS_URL}?projectId=${projectId}&messageMedium=${messageMedium}`);

export const fetchExperimentsTableData = (variables: ExperimentsTableQuery) =>
  client.query({ query: fetchExperimentsTableDataQuery, variables });

export const fetchCampaignLabelsWithExperiments = () =>
  client.query({ query: fetchCampaignLabelsQuery });

export const fetchCampaignMediumWithExperiments = () =>
  client.query({ query: fetchMessageMediumsQuery });

export const fetchExperimentConversionsByEventNames = () =>
  client.query({ query: fetchConversionsByEventNamesQuery });

export const fetchExperimentAnalyticsBasePage = (id: number) =>
  client.query({ query: fetchExperimentAnalyticsBasePageQuery, variables: { id } });

export const fetchExperimentAnalyticsOverviewTab = (id: number) =>
  client.query({ query: fetchExperimentAnalyticsOverviewTabQuery, variables: { id } });

export const fetchExperimentAnalyticsPerformanceTab = (variables: AnalyticsQuery) =>
  client.query({ query: fetchExperimentAnalyticsPerformanceTabQuery, variables });

export const fetchExperiment = (id: number, locale?: string) =>
  client.query({ query: fetchExperimentEditQuery, variables: { id, locale } });

export const fetchExperimentAnalyticsMetrics = (messageMedium: MessageMedium) =>
  client.query({
    query: fetchAnalyticsMetrics,
    variables: { messageMedium, page: 'CampaignAnalytics' },
  });

export const fetchChooseCampaigns = ({
  limit,
  offset,
  search,
  sortBy,
  sortDirection,
}: {
  limit: number;
  offset: number;
  search: string;
  sortBy: CHOOSE_CAMPAIGN_COLUMN_SORT_ENUM;
  sortDirection: SORT_DIRECTIONS;
}) =>
  client.query({
    query: fetchCampaignsQuery,
    variables: {
      pagination: { limit, offset },
      search,
      sort: {
        sortBy,
        sortDirection,
      },
    },
  });
